import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetStudentInGroupBySessionResponse {
  count: number;
  data: Array<Student>;
  pagination: Pagination;
}

export interface Student {
  id: string;
  name: string;
}

export interface Pagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface GetStudentsInGroupBySessionParams {
  sessionId: string;
  groupId: string;
  showAll?: boolean;
  page?: number;
  limit?: number;
}

export const getStudentsInGroupBySessionAPI = async (
  params: GetStudentsInGroupBySessionParams,
) => {
  const response = await baseAPI.get<GetStudentInGroupBySessionResponse>(
    `/students/search/session-group/${params.sessionId}/${params.groupId}`,
    {
      params: {
        showAll: params.showAll,
        page: params.page,
        limit: params.limit,
      },
    },
  );
  return response.data;
};

export const getStudentsInGroupBySessionQueryOptions = (
  params: GetStudentsInGroupBySessionParams,
) =>
  queryOptions({
    queryKey: [
      KEYS.STUDENTS_IN_GROUP_BY_SESSION,
      params.sessionId,
      params.groupId,
    ],
    queryFn: () => getStudentsInGroupBySessionAPI(params),
    placeholderData: keepPreviousData,
    enabled: !!params.sessionId && !!params.groupId,
  });

export const useGetStudentsInGroupBySession = (
  params: GetStudentsInGroupBySessionParams,
) => {
  return useQuery(getStudentsInGroupBySessionQueryOptions(params));
};
